import { render, staticRenderFns } from "./ShortVideoFloat.vue?vue&type=template&id=ec6ce65c&scoped=true"
import script from "./ShortVideoFloat.vue?vue&type=script&lang=js"
export * from "./ShortVideoFloat.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoFloat.vue?vue&type=style&index=0&id=ec6ce65c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6ce65c",
  null
  
)

export default component.exports